import { baseService } from "../base";
import {
  CreateFileDto,
  CreateMultipleFilesDto,
  FileParams,
  GetFilesParams,
} from "./file.types";
import { PaginationResponse } from "../type";
import { TFile } from "~/types";

export const fileServices = {
  getFiles: async (params?: GetFilesParams) => {
    const { data } = await baseService.get<PaginationResponse<TFile>>(
      "/files",
      {
        params,
      }
    );
    return data;
  },

  getFile: async (id: string) => {
    const { data } = await baseService.get<TFile>(`/files/${id}`);
    return data;
  },

  getMyFiles: async (params?: GetFilesParams) => {
    const { data } = await baseService.get<PaginationResponse<TFile>>(
      "/files/my-file",
      {
        params,
      }
    );
    return data;
  },

  createFile: async (dto: CreateFileDto) => {
    const fileData = new FormData();

    if (dto.file) fileData.append("file", dto.file);
    if (dto.title) fileData.append("title", dto.title);
    if (dto.type) fileData.append("type", dto.type.toString());
    if (dto.status) fileData.append("status", dto.status.toString());
    if (dto.serviceTicketId)
      fileData.append("serviceTicketId", dto.serviceTicketId);
    if (dto.taskId) fileData.append("taskId", dto.taskId);
    if (dto.clientId) fileData.append("clientId", dto.clientId);
    if (dto.filePath) fileData.append("filePath", dto.filePath);
    if (dto.staffId) fileData.append("staffId", dto.staffId);
    if (dto.jobTicketId) fileData.append("jobTicketId", dto.jobTicketId);
    if (dto.visibleToStaff !== undefined)
      fileData.append("visibleToStaff", dto.visibleToStaff.toString());
    if (dto.visibleToClient !== undefined)
      fileData.append("visibleToClient", dto.visibleToClient.toString());

    const { data } = await baseService.post<TFile>("/files", fileData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },

  createFiles: async (dto: CreateMultipleFilesDto) => {
    const formData = new FormData();

    // Append files to formData with the key "files"
    dto.files.forEach((item, index) => {
      if (item.file) {
        formData.append(`files[${index}][file]`, item.file);
      }

      if (item.title) formData.append(`files[${index}][title]`, item.title);
      if (item.type)
        formData.append(`files[${index}][type]`, item.type.toString());
      if (item.status)
        formData.append(`files[${index}][status]`, item.status.toString());
      if (item.serviceTicketId)
        formData.append(
          `files[${index}][serviceTicketId]`,
          item.serviceTicketId
        );
      if (item.taskId) formData.append(`files[${index}][taskId]`, item.taskId);
      if (item.clientId)
        formData.append(`files[${index}][clientId]`, item.clientId);
      if (item.staffId)
        formData.append(`files[${index}][staffId]`, item.staffId);
      if (item.visibleToStaff !== undefined)
        formData.append(`files[${index}][visibleToStaff]`, item.visibleToStaff.toString());
      if (item.visibleToClient !== undefined)
        formData.append(`files[${index}][visibleToClient]`, item.visibleToClient.toString());
      if (item.expires)
        formData.append(`files[${index}][expires]`, item.expires);
    });

    const { data } = await baseService.post<TFile>(
      "/files/multiple",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  },

  updateFile: async ({ id, ...fileData }: FileParams & { id: string }) => {
    const formData = new FormData();

    Object.entries(fileData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === "file" && value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, String(value));
        }
      }
    });

    const { data } = await baseService.patch<TFile>(`/files/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },

  deleteFile: async (id: string) => {
    const { data } = await baseService.delete(`/files/${id}`);
    return data;
  },
};
